import { type ReactNode, useEffect, useState } from 'react'
import i18n from './index'

interface I18nProviderProps {
  children: ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const initI18n = async () => {
      await i18n.init()
      setIsInitialized(true)
    }
    initI18n()
  }, [])

  if (!isInitialized) {
    return null
  }

  return <>{children}</>
}
